import React from "react";

/**
 * Connected / Not Connected pill — used in WA Business settings cards across
 * Shop, Distributor, and Admin panels.
 */
export default function WaStatusPill({ connected, testIdPrefix = "wa" }) {
  return connected ? (
    <span
      className="inline-flex items-center gap-1.5 rounded-full bg-emerald-50 border border-emerald-300 text-emerald-700 px-3 py-1 text-xs font-bold uppercase tracking-wider"
      data-testid={`${testIdPrefix}-status-connected`}
    >
      <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse" />
      Connected
    </span>
  ) : (
    <span
      className="inline-flex items-center gap-1.5 rounded-full bg-red-50 border border-red-300 text-red-700 px-3 py-1 text-xs font-bold uppercase tracking-wider"
      data-testid={`${testIdPrefix}-status-disconnected`}
    >
      <span className="w-2 h-2 rounded-full bg-red-500" />
      Not Connected
    </span>
  );
}
